import { render, staticRenderFns } from "./AcceptCommentsModal.vue?vue&type=template&id=5a278b78"
import script from "./AcceptCommentsModal.vue?vue&type=script&lang=js"
export * from "./AcceptCommentsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports